import {useState,useEffect} from 'react'
import { Router, useParams } from 'react-router-dom'
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import CountdownTimer from '../../components/CountdownTimer';
import { InformationCircle, Send } from 'react-ionicons';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";

const DealPage = () => {

    const navigate = useNavigate();

    const API_URL = process.env.REACT_APP_API_URL
    const GET_DEAL = `${API_URL}/deal-single`

    const {dealno} = useParams();
    const [data,setData] = useState();
    const [dealDetail,setDealDetail] = useState();
    const [selectedID, setSelectedID] = useState();
    const [selectedAttrSizes,setSelectedAttrSizes] = useState();
    const [sizeDetail, setSizeDeatils] = useState();
    const [selectedSizeID, setSelectedSizeID] = useState();
    const [loading,setLoading] = useState(false);

    console.log(dealno);

    const getDeal = async ()=>{
        setLoading(true)
        try {
            await axios.post(GET_DEAL,{deal_no:dealno})
            .then((response)=>{
                console.log(response.data.data)
                setData(response.data.data)
                setDealDetail(response.data.data.default_color)
                setSizeDeatils(response.data.data.default_color?.sizes[0])
                setSelectedAttrSizes(response.data.data.default_color?.sizes)
                setSelectedID(response.data.data.default_color?.sizes[0].size)
                setLoading(false)
            })
        } catch (error) {   
            console.error(error)
            setLoading(false)
        }
    }

    useEffect(()=>{
        getDeal()
    },[dealno])

    const formatDate = (myDate) =>{
      const date = new Date(myDate);
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
    
      return `${month}-${day}-${year}`;
    }

    const getBelowCostPercentage = (currentPrice,actualPrice)=>{
      const percentChange = (((currentPrice - actualPrice) / actualPrice) * 100).toFixed(2);
      const display = (percentChange > 0 ? '+' : '') + percentChange + '%';
      return display;
    }


  return (
    <>
    <Helmet>
        <title>{data?.deal_no}</title>
        <meta property="og:title" content={data?.name} />
        <meta property="og:description" content={data?.deal_no} />
        <meta property="og:image" content={data?.default_color?.image} />
        <meta property="og:url" content={``} />
        <meta property="og:type" content="Web" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={data?.name} />
        <meta name="twitter:description" content={data?.deal_no} />
        <meta name="twitter:image" content={data?.default_color?.image} />
      </Helmet>
    <nav className="navbar navbar-light bg-white">
        <div className="container justify-content-center">
          <a className="navbar-brand mx-auto" href="/">
            <img
              src="https://makemoneyormiles.com/media/logos/logo.png"
              alt="MakeMoneyorMiles.com"
              style={{height:'75px'}}
              className="d-inline-block align-text-top"
            />
          </a>
        </div>
      </nav>
    <div className='container mt-5 mb-5'>
        <div>
          <div className='card mt-5'>
            <div className='ribbon ribbon-start ribbon-clip' style={{top: '10px'}}>
              {data?.status === 1 ? (
                <div className='ribbon-label'>
                  {data?.deal_stock == 'true' ? 'In Stock' : 'Commitment Full'}
                  {data?.deal_stock == 'true' ? (
                    <span className='ribbon-inner bg-info'></span>
                  ) : (
                    <span className='ribbon-inner bg-danger'></span>
                  )}
                </div>
              ) : (
                <div className='ribbon-label'>
                  Expired
                  <span className='ribbon-inner bg-warning'></span>
                </div>
              )}
            </div>
            <div className='row col-12'>
              <div className="col-lg-6 col-md-12">
              <div className='card-body d-flex flex-column justify-content-between'>
                <div className={`card-rounded text-center`}>
                  <img
                    src={dealDetail?.image ? dealDetail?.image : data?.default_color?.image}
                    // src={'https://erp.makemoneyormiles.com/storage/deals/376474.webp'}
                    alt=''
                    style={{width: '100%', height: 'auto'}}
                  />
                </div>

              </div>
              <div className="timer d-none d-lg-block">
                <CountdownTimer targetDate={data?.expires}/>
              </div>
            </div>

              <div className='col-lg-6 col-md-12 mt-5'>
                <div className='mb-5 ms-5'>
                  <div className='d-flex flex-wrap'>
                    {sizeDetail?.stock ? (
                    <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>{Math.max(sizeDetail?.stock - sizeDetail?.commited_qty, 0)}</span>
                      </div>
                      <div className='fw-semibold text-muted'>Available Qty</div>
                    </div>
                    ) : (
                      <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>0</span>
                      </div>
                      <div className='fw-semibold text-muted'>Available Qty</div>
                    </div>
                    )}

                    <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3 mx-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>{data?.user_limit}</span>
                      </div>
                      <div className='fw-semibold text-muted'>Maximum Order Limit</div>
                    </div>


                  </div>
                  <div className='mt-2 mx-5 mx-lg-0'>
                    <div className='card-rounded p-2 z-index-1 bg-body'>
                      <div
                        className='shadow-xs align-items-center'
                        style={{marginLeft: '-15px', marginTop: '-15px', padding: '10px'}}
                      >
                        <div className='d-flex align-items-center flex-wrap w-100'>
                          <div className='pe-3 flex-grow-1'>
                          <h5 className="mt-3">Deal ID : <u>{data?.deal_no}</u></h5>
                            <h4><a href='#' className='fs-4 fw-bold text-gray-700 text-hover-dark mt-3'>
                              <strong>
                                {data?.name}-{data?.color}&nbsp;{(sizeDetail?.size != 'OS') ? sizeDetail?.size_name : ''}
                              </strong>
                            </a></h4>
                            
                            <div className='d-flex align-items-center mt-5'>
                              <div className='me-5'>
                                <div className='fs-5 symbol-label'>Model:</div>
                                <div className='fs-5 symbol-label'>Deal Expires:</div>
                                <div className='fs-5 symbol-label'>Price:</div>
                                  <div className='fs-5 symbol-label'>Commission:</div>
                                <div className='fs-5 fw-bold symbol-label'>Total:</div>
                              </div>
                              <div className=''>
                                <div className='fs-5 text-gray-800 pe-1'>{dealDetail?.model}</div>
                                <div className='fs-5 text-gray-800 pe-1'>{formatDate(data?.expires)}</div>
                                <div className='fs-5 text-gray-800 pe-1'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail?.price).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                  {(data?.below_cost == 1) && (
                                  <span className='text-muted text-decoration-line-through ms-3'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail?.commission).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                  </span>
                                  )}
                                  {(data?.below_cost == 1) && (
                                    <span className="fs-8 py-1 px-2 ms-2" style={{color:'#ffffffff',borderRadius:8,backgroundColor:'#ff8484ff'}}>{getBelowCostPercentage(Number(sizeDetail?.price),sizeDetail?.commission)}</span>
                                      )}
                                </div>
                                  <div className='fs-5 text-gray-800 pe-1'>
                                    <CurrencyFormat
                                      decimalScale={2}
                                      value={(data?.commission_status == 1) ? sizeDetail?.commission.toFixed(2) : '0.00'}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'$'}
                                    />
                                  </div>

                                <div className='fw-bold fs-5 text-gray-800 pe-1'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail?.total).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                </div>
                              </div>
                            </div>
                            <div>
                              {(selectedAttrSizes?.length > 1) && (selectedAttrSizes[0]?.size != 'OS') && (
                              <ul className='deal_sizes'>
                                <div className='mt-3 fs-5 mb-2'>Sizes Available:</div>
                                
                                {selectedAttrSizes?.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        setSizeDeatils(item)
                                        setSelectedSizeID(item.size)
                                      }}
                                    >
                                      
                                      <button className={item.size == selectedSizeID
                                            ? 'size-btn-selected'
                                            : 'size-btn'
                                        }>
                                        <span className='sizeBox mx-2'>{item.size_name}</span>
                                      </button>
                                    </li>
                                  )
                                })}
                              </ul>
                              )}
                              <ul className='deal_colors'>
                                <div className='mt-3 fs-5 mb-2'>Color Available:</div>
                                {data?.colors.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        setDealDetail(item)
                                        setSelectedID(item.attribute_code)
                                        setSelectedAttrSizes(item.sizes)
                                        setSizeDeatils(item.sizes[0])
                                        setSelectedSizeID(item.sizes[0].size)
                                      }}
                                    >
                                      <div
                                        className={
                                          item.attribute_code == selectedID
                                            ? 'color-item deal_colors_selected'
                                            : 'color-item deal_colors_select'
                                        }
                                        style={{borderColor: `${item.color_code}`}}
                                      >
                                        <div
                                          className='colorBox'
                                          style={{background: `${item.color_code}`,border:'2px solid black'}}
                                        ></div>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className='mt-5'>
                          <div className='d-flex align-items-center col-12'>
                            <div className='col-12 d-flex'>
                              <div  className='mt-3 fs-5'>Shipping Location : {dealDetail?.shipping_address} - 
                                <span>{dealDetail?.shipping_zipcode}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-top border-2 my-2"></div>
                        <div className='d-flex'>
                            {sizeDetail?.stores.map((item, index) => {
                              return (
                                <a
                                  key={index}
                                  href={item?.store_url}
                                  target='_blank'
                                  className='symbol symbol-40px me-2 card shadow-xs p-1'
                                  style={{borderRadius:'50%'}}
                                  data-bs-toggle='tooltip'
                                  title={item?.store?.name}
                                >
                                  <img
                                    src={item?.store?.image}
                                    alt='store'
                                    style={{height: '30px', width: ' 30px'}}
                                  />
                                </a>
                              )
                            })}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                  
                <p className='fs-5 ms-5'><i class="fa-solid fa-bullhorn me-2 text-dark fa-3x"></i><b>Note</b> :- {dealDetail?.note ? dealDetail?.note : 'There is nothing'}</p>
                <hr />
                <div className='d-flex justify-content-end' style={{paddingRight: '10px', paddingBottom: '10px'}}>
                    <button
                        type='button'
                        className='btn btn-success fw-bold me-0 me-lg-2'
                        onClick={()=> navigate('/deals',{ state:{openDealDetailModal:true,deal:data}})}
                    >
                        View Deal&nbsp;&nbsp;<InformationCircle color={'white'}  height="15px" width="15px" />
                    </button>
                {data?.deal_stock == 'true' && data?.freezed_status == 0 && (
                    <>
                    <button
                        type='button'
                        className='btn btn-secondary fw-bold me-0 me-lg-2'
                        onClick={()=> navigate('/deals',{ state:{openDealCommitModal:true,deal:data,size:sizeDetail,color:dealDetail}})}
                    >
                        Commit Now&nbsp;&nbsp;<Send color={'white'}  height="15px" width="15px" />
                    </button>
                    </>
                )}
                {data?.deal_stock == 'false' && data?.freezed_status == 0 && (
                    <>
                    <button
                        type='button'
                        className='btn btn-secondary fw-bold me-0 me-lg-2'
                    >
                        Commitment Full
                    </button>
                    </>
                )}
                {data?.status != 1 && data?.freezed_status == 0 && (
                    <>
                    <button
                        type='button'
                        className='btn btn-danger fw-bold me-0 me-lg-2'
                    >
                        Expired
                    </button>
                    </>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        
    </div>
    <footer className="bg-white text-center mt-auto " style={{paddingTop:30,paddingBottom:30}}>
        <h5>© {new Date().getFullYear()} MakeMoneyorMiles. All rights reserved.</h5>
      </footer>
    </>
  )
}

export default DealPage